export default function (value) {
  return value.trim() || null;
}